import { useTranslation } from 'react-i18next';
import DataModule from '../../DataModules';
import { Box, Button, Divider, Typography } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { hasPermissions } from '../../../../auth/hasPermissions';
import SpeedDialMenu from '../../../../components/menu/SpeedDialMenu';
import DateLabel from '../../../../components/label/DateLabel';
import DateTimeLabel from '../../../../components/label/DateTimeLabel';

export const ContractNode = ({ data }) => {
  const { t } = useTranslation();
  const canWrite = hasPermissions('employee-contract', 'write');

  const dataModules = [
    {
      type: 'text',
      label: t('Updated At'),
      value: <DateTimeLabel dateTime={data.updatedAt} />,
    },
    {
      type: 'text',
      label: t('Description'),
      value: data.description,
    },
    {
      type: 'text',
      label: t('Full Time'),
      value: data.fullTime ? t('yes') : t('no'),
    },
    {
      type: 'text',
      label: t('Main Job'),
      value: data.mainJob ? t('yes') : t('no'),
    },
    {
      type: 'text',
      label: t('Pay Type'),
      value: data.payType ? t('per Hour') : t('flat'),
    },
    {
      type: 'date',
      label: t('Start Date'),
      value: <DateLabel date={data.startDate} />,
    },
    {
      type: 'date',
      label: t('Valid Until'),
      value: data.validUntil ? (
        <DateLabel date={data.validUntil} />
      ) : (
        t('unlimited')
      ),
    },
  ];

  const actions = [
    {
      icon: <FileDownloadIcon />,
      name: t('Contract'),
      onClick: () => {
        if (data.unsignedContract)
          window.open(data.unsignedContract.temporaryUrl, '_blank');
      },
      disabled: !data.unsignedContract,
    },
    {
      icon: <FileDownloadIcon />,
      name: t('Signed'),
      onClick: () => {
        if (data.signedContract)
          window.open(data.signedContract.temporaryUrl, '_blank');
      },
      disabled: !data.signedContract,
    },
    {
      icon: <FileUploadIcon />,
      name: t('Upload signed Contract'),
      onClick: () => data.onSign(data),
      hidden: !data.signedContract,
    },
    {
      icon: <EditIcon />,
      name: t('Edit Contract'),
      onClick: () => data.onEdit(data),
      hidden: !data.onEdit || Boolean(data.signedContract) || !canWrite,
    },
    {
      icon: <DeleteOutlineIcon />,
      name: t('Delete'),
      onClick: () => data.onDelete(data),
      hidden: !data.onDelete || Boolean(data.signedContract) || !canWrite,
    },
  ];

  return (
    <Box className="w-full @container relative">
      <Box>
        <Typography className="opacity-50" fontSize={10}>
          {t('Contract Nr')}
        </Typography>
        <Typography className="monospace" fontWeight={600}>
          {data.nr}
        </Typography>
      </Box>
      {dataModules.map((display, index) => (
        <Box>
          <Typography className="opacity-50" fontSize={10}>
            {display.label}
          </Typography>
          <Typography>{display.value}</Typography>
        </Box>
      ))}
      {!data.signedContract && (
        <Box className="pt-2">
          <Button
            onClick={() => data.onSign(data)}
            variant="contained"
            color="secondary"
            className="flex items-center gap-2"
          >
            <FileUploadIcon />
            {t('Upload signed Contract')}
          </Button>
        </Box>
      )}
      <SpeedDialMenu actions={actions} noBlur />
      <Divider className="pt-4" />
    </Box>
  );
};
